// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const earlyAccessApi = baseApi.injectEndpoints({
  credentials: "include",
  endpoints: (builder) => ({
    addEA: builder.mutation({
      query: (data) => {
        return {
          url: "early-access-incentives",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    updateEA: builder.mutation({
      query: ({ data, id }) => {
        return {
          url: `early-access-incentives/${id}`,
          method: "PATCH",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    deleteEA: builder.mutation({
      query: (id) => {
        return {
          url: `early-access-incentives/${id}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    getAllEA: builder.query({
      query: (query) => {
        let queryString = new URLSearchParams(query).toString();
        return {
          url: `early-access-incentives?${queryString}`, // todo:
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    uploadCSV: builder.mutation({
      query: (data) => {
        return {
          url: "early-access-incentives/bulk-csv",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    bulkCreate: builder.mutation({
      query: (data) => {
        return {
          url: "early-access-incentives/bulk",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useAddEAMutation,
  useUpdateEAMutation,
  useDeleteEAMutation,
  useGetAllEAQuery,
  useUploadCSVMutation,
  useBulkCreateMutation,
} = earlyAccessApi;
